module.exports = __webpack_public_path__ + "assets/icons/toolbar-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/logo/toolbar-logo.png
// module id = ./src/styles/icons/logo/toolbar-logo.png
// module chunks = 0